//#region src/model_type.ts
var ModelType = /* @__PURE__ */ function(ModelType) {
	ModelType[ModelType["DbSettings"] = 0] = "DbSettings";
	ModelType[ModelType["Menu"] = 1] = "Menu";
	ModelType[ModelType["MenuItem"] = 2] = "MenuItem";
	ModelType[ModelType["MenuSection"] = 3] = "MenuSection";
	ModelType[ModelType["ModGroup"] = 4] = "ModGroup";
	ModelType[ModelType["Badge"] = 5] = "Badge";
	ModelType[ModelType["DictionaryWord"] = 6] = "DictionaryWord";
	ModelType[ModelType["MenuCover"] = 9] = "MenuCover";
	ModelType[ModelType["MenuStructure"] = 10] = "MenuStructure";
	ModelType[ModelType["MenuTiming"] = 11] = "MenuTiming";
	ModelType[ModelType["User"] = 12] = "User";
	ModelType[ModelType["Mod"] = 13] = "Mod";
	ModelType[ModelType["Location"] = 14] = "Location";
	ModelType[ModelType["Order"] = 16] = "Order";
	ModelType[ModelType["BiteLog"] = 17] = "BiteLog";
	ModelType[ModelType["KioskStatus"] = 18] = "KioskStatus";
	ModelType[ModelType["Guest"] = 19] = "Guest";
	ModelType[ModelType["Transaction"] = 21] = "Transaction";
	ModelType[ModelType["TaxProfile"] = 22] = "TaxProfile";
	ModelType[ModelType["Kiosk"] = 23] = "Kiosk";
	ModelType[ModelType["ReportSchedule"] = 24] = "ReportSchedule";
	ModelType[ModelType["Counter"] = 25] = "Counter";
	ModelType[ModelType["MaitredActivity"] = 30] = "MaitredActivity";
	ModelType[ModelType["QuicksandRecord"] = 31] = "QuicksandRecord";
	ModelType[ModelType["Org"] = 36] = "Org";
	ModelType[ModelType["Integration"] = 37] = "Integration";
	ModelType[ModelType["Vendor"] = 38] = "Vendor";
	ModelType[ModelType["Coupon"] = 40] = "Coupon";
	ModelType[ModelType["Build"] = 42] = "Build";
	ModelType[ModelType["LocationGroup"] = 43] = "LocationGroup";
	ModelType[ModelType["UserRole"] = 44] = "UserRole";
	ModelType[ModelType["ExternalAuthStrategy"] = 45] = "ExternalAuthStrategy";
	ModelType[ModelType["Customer"] = 46] = "Customer";
	ModelType[ModelType["CustomerPaymentMethod"] = 47] = "CustomerPaymentMethod";
	ModelType[ModelType["CustomerLoginAttempt"] = 48] = "CustomerLoginAttempt";
	ModelType[ModelType["CustomerFavorites"] = 49] = "CustomerFavorites";
	ModelType[ModelType["ExpoPrinter"] = 50] = "ExpoPrinter";
	ModelType[ModelType["LocationThrottle"] = 51] = "LocationThrottle";
	ModelType[ModelType["RejectedTransaction"] = 52] = "RejectedTransaction";
	ModelType[ModelType["DeletedEntry"] = 53] = "DeletedEntry";
	ModelType[ModelType["SystemHealthSummary"] = 55] = "SystemHealthSummary";
	ModelType[ModelType["SystemHealthIncident"] = 56] = "SystemHealthIncident";
	ModelType[ModelType["Site"] = 57] = "Site";
	ModelType[ModelType["RecommendationResult"] = 58] = "RecommendationResult";
	ModelType[ModelType["CustomerDeliveryAddress"] = 60] = "CustomerDeliveryAddress";
	ModelType[ModelType["CustomerPushToken"] = 61] = "CustomerPushToken";
	ModelType[ModelType["RecommendationRule"] = 62] = "RecommendationRule";
	ModelType[ModelType["OpenHoursOverride"] = 63] = "OpenHoursOverride";
	ModelType[ModelType["RecommendationVariation"] = 64] = "RecommendationVariation";
	ModelType[ModelType["MenuItemAffinities"] = 65] = "MenuItemAffinities";
	ModelType[ModelType["Appearance"] = 66] = "Appearance";
	ModelType[ModelType["OpenHoursTimetable"] = 67] = "OpenHoursTimetable";
	ModelType[ModelType["OrderTotalRollup"] = 68] = "OrderTotalRollup";
	ModelType[ModelType["Webhook"] = 69] = "Webhook";
	ModelType[ModelType["OloOrder"] = 70] = "OloOrder";
	ModelType[ModelType["MenuCoverPromo"] = 71] = "MenuCoverPromo";
	ModelType[ModelType["QueueJobMetadata"] = 72] = "QueueJobMetadata";
	ModelType[ModelType["Changeset"] = 73] = "Changeset";
	ModelType[ModelType["Settings"] = 74] = "Settings";
	ModelType[ModelType["KorTick"] = 75] = "KorTick";
	ModelType[ModelType["IntegrationSupplementaryData"] = 76] = "IntegrationSupplementaryData";
	ModelType[ModelType["QuizStep"] = 77] = "QuizStep";
	ModelType[ModelType["Quiz"] = 78] = "Quiz";
	ModelType[ModelType["ReportingOrder"] = 79] = "ReportingOrder";
	ModelType[ModelType["ReportingLocation"] = 80] = "ReportingLocation";
	ModelType[ModelType["ThirdPartyOrder"] = 81] = "ThirdPartyOrder";
	ModelType[ModelType["CompoundModGroup"] = 82] = "CompoundModGroup";
	ModelType[ModelType["LoyaltySignup"] = 83] = "LoyaltySignup";
	ModelType[ModelType["KorAlertSubscription"] = 84] = "KorAlertSubscription";
	ModelType[ModelType["KorAlertIncident"] = 85] = "KorAlertIncident";
	ModelType[ModelType["AffinityRule"] = 86] = "AffinityRule";
	ModelType[ModelType["OrgChunkConfig"] = 89] = "OrgChunkConfig";
	ModelType[ModelType["MenuItemAffinityRun"] = 90] = "MenuItemAffinityRun";
	ModelType[ModelType["EnterpriseTag"] = 91] = "EnterpriseTag";
	ModelType[ModelType["ScopedSequenceState"] = 92] = "ScopedSequenceState";
	ModelType[ModelType["AffinityGenerationRun"] = 93] = "AffinityGenerationRun";
	ModelType[ModelType["OrgCategoryStats"] = 94] = "OrgCategoryStats";
	ModelType[ModelType["DbMigration"] = 95] = "DbMigration";
	ModelType[ModelType["OpportunityAnalysisRun"] = 96] = "OpportunityAnalysisRun";
	ModelType[ModelType["ArchiveCursor"] = 97] = "ArchiveCursor";
	ModelType[ModelType["Portfolio"] = 98] = "Portfolio";
	ModelType[ModelType["ArchiveParity"] = 99] = "ArchiveParity";
	return ModelType;
}(ModelType || {});
//#endregion
export { ModelType };

//# sourceMappingURL=model_type.js.map